import styles from './_.module.css'

const NewTag = () => <span className={styles.tag}>New</span>

export default NewTag
